var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general"},[_c('h4',[_vm._v(_vm._s(_vm.$t('graphs.general')))]),_c('div',{staticClass:"general-wrapper"},[_c('div',{staticClass:"general-item"},[_c('canvas',{attrs:{"id":_vm.chart.id}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }